import React, { useState, useEffect } from 'react';
import axios from "axios";
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { Auth } from 'aws-amplify';

import {
    FormBlock,
    FormTitle,
    HalfBlock,
} from "../../../generalStyles/mixin";
import * as env from "../../../environment";

const { API_URL_BACKEND } = env[process.env.NODE_ENV];

function DespachoDigitalConfigComponent() {

    const [ventanaIni, setVentanaIni] = useState("")
    const [ventanaFin, setVentanaFin] = useState("")
    //const [ventanaDel, setVentanaDel] = useState("")

    useEffect(() => {
        // Llamamos a la API para obtener la ventana existente
        obtieneVentana()
    }, []);

    const validaHoraSubmit = (value) => {
        if(value.length<4) {
            return false
        }

        const hora = parseInt(value.substring(0,2), 10)
        const minuto = parseInt(value.substring(2,4), 10)
        if(hora < 0 || hora > 23) {
            return false
        }

        if(minuto < 0 || minuto > 59) {
            return false
        }

        return true
    }

    const actualizaVentana = async () => {
        if(!validaHoraSubmit(ventanaIni)) {
            alert("Formato de hora de inicio incorrecto")
            return
        }

        if(!validaHoraSubmit(ventanaFin)) {
            alert("Formato de hora de fin incorrecto")
            return
        }

        const request1 = {
            //mail_ventana_inicio: ventanaIni,
            //mail_ventana_fin: ventanaFin,
            llave: 'hora_inicio',
            valor: ventanaIni
        }
        const request2 = {
            //mail_ventana_inicio: ventanaIni,
            //mail_ventana_fin: ventanaFin,
            llave: 'hora_fin',
            valor: ventanaFin
        }
        console.log("Actualizamos : " + JSON.stringify(request1) + " - " + JSON.stringify(request2))
        const endpoint = `${API_URL_BACKEND}/ventana/despachodigital`

        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            }
        };

        try {
            const response1 = await axios.post(endpoint, request1, config)
            const response2 = await axios.post(endpoint, request2, config)

            if (response1.status === 200 && response2.status === 200) {
                alert("Actualizacion correcta")
            } else {
                alert("Error " + response1.status + " : " + response1.message, " - " + response2.status + " : " + response2.message)
            }
        } catch (e) {
            alert("No se pudo actualizar")
            console.error("No se pudo actualizar", e)
        }
    }

    const validaHora = (value) => {
        if(value.includes("e")) {
            return false
        }
        if(!Number.isNaN(value)) {
            console.log(value + " si")
            if(value.length>4) {
                return false
            }
           
            return true
        } else {
            console.log(value + " no")
            return false
        }
      }

    const obtieneVentana = async () => {
        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            }
        };

        const nombreSubCfg = 'despacho_digital_config'
        const endpoint = `${API_URL_BACKEND}/ventana/despachodigital`

        console.log("Llamando al endpoint [" + endpoint + "] con el sub config [" + nombreSubCfg + "]")

        try {
            const response = await axios.get(endpoint, config)

            if (response.status === 200) {
                console.log("Respuesta", response.data.data)

                for(const unRegistro of response.data.data) {
                    if(unRegistro.llave == 'hora_inicio') {
                        setVentanaIni(unRegistro.valor)
                    }
                    if(unRegistro.llave == 'hora_fin') {
                        setVentanaFin(unRegistro.valor)
                    }
                }
            } else {
                alert("error " + response.status + " : " + response.message)
            }
        } catch (e) {
            setVentanaIni("")
            setVentanaFin("")
            //setVentanaDel("1")
        }
        
    }

    const refreshToken = async () => {
        try {
          const cognitoUser = await Auth.currentAuthenticatedUser();
          const { refreshToken } = cognitoUser.getSignInUserSession();
          cognitoUser.refreshSession(refreshToken, (err, session) => {
            const { accessToken } = session;
            localStorage.setItem("token", accessToken.jwtToken);
          });
        } catch (e) {
          localStorage.clear();
          window.location = '/';
        }
      };

    return (<>
        <FormBlock>
            <FormTitle>Configuración despachos digitales</FormTitle>
            <HalfBlock>
                <TextField
                    placeholder="0800"
                    type="number"
                    label="Inicio de la ventana. formato (HHMM)"
                    inputProps={{ maxLength: 4 }}
                    size='4'
                    
                    value={ventanaIni}
                    onChange={(ev) => {
                        if(validaHora(ev.target.value)) {
                          setVentanaIni(ev.target.value );
                        }
                      }}
                />
                <TextField
                    placeholder="2000"
                    type="number"
                    label="Fin de la ventana. formato (HHMM)"
                    inputProps={{ maxLength: 4 }}
                    value={ventanaFin}
                    onChange={(ev) => {
                        setVentanaFin(ev.target.value );
                    }}
                />

                <DialogActions>
                    <Button onClick={actualizaVentana} color="primary">
                        Actualizar
                    </Button>
                </DialogActions>
            </HalfBlock>
            

        </FormBlock>
    </>
    )
}

export default DespachoDigitalConfigComponent;